

export function cloneData(data){
    var json=JSON.stringify(data);
    return JSON.parse(json);
}